import { registerBlock } from "../../registry";
import { makeId } from "../../helpers";
import type { ContentBlock } from "../../types";

const test: ContentBlock<"test"> = {
  id: makeId("test-lining-check"),
  kind: "test",
  tags: ["clinic-visit", "her", "during-cycle", "fet", "ivf", "testing"],
  title: "Lining Check Ultrasound",
  subtitle: "Ultrasound to measure endometrial thickness during FET prep",
  body: {
    testName: "Endometrial Lining Check",
    category: "monitoring",
    whatItMeasures:
      "Measures the thickness and pattern of the endometrial lining during a frozen embryo transfer (FET) preparation cycle. Your clinic interprets these findings with the protocol, laboratory results, timing, and your history when deciding whether to continue, adjust, or schedule treatment.",
    howItWorks:
      "The clinic may use a transvaginal ultrasound during preparation to assess the lining. Monitoring timing and the findings considered ready vary by protocol and clinic; a single thickness or pattern is not a universal readiness rule. Your care team decides whether to continue the plan, change it, or schedule another assessment. Follow the medication order you were given, and ask the clinic how to prepare for the ultrasound and what bleeding or spotting to report.",
    quickFacts: [
      { kind: "sample", value: "Transvaginal ultrasound" },
      { kind: "time", value: "5-10 min scan" },
      { kind: "pain", value: "Pressure, usually mild" },
      { kind: "prep", value: "Empty bladder; keep meds as directed" },
      { kind: "results", value: "During the appointment" },
    ],
    costRange: { low: 200, high: 500 },
    atHome: false,
    clinicRequired: true,
    cycleDay: "FET preparation — timing is set by your clinic's protocol",
    dataPoints: [makeId("dp-endometrial-thickness")],
    section: "implantation",
  },
  sources: [
    {
      title:
        "Endometrial thickness and pregnancy rates after IVF: a systematic review and meta-analysis",
      authors:
        "Kasius A, Smit JG, Torrance HL, Eijkemans MJC, Bossuyt PM, Opmeer BC, Broekmans FJM",
      journal: "Human Reproduction Update",
      year: 2014,
      url: "https://academic.oup.com/humupd/article/20/4/530/2952657",
      evidenceLevel: "meta-analysis",
    },
    {
      title: "ESHRE guideline: ovarian stimulation for IVF/ICSI",
      authors: "ESHRE Guideline Group on Ovarian Stimulation",
      journal: "Human Reproduction Open",
      year: 2020,
      url: "https://academic.oup.com/hropen/article/2020/2/hoaa009/5826933",
      evidenceLevel: "guideline",
    },
  ],
  readTimeMinutes: 3,
};

registerBlock(test);
